import { render, staticRenderFns } from "./ImportVoting.vue?vue&type=template&id=f1d24552"
import script from "./ImportVoting.vue?vue&type=script&lang=js"
export * from "./ImportVoting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports